import { createContext } from "react";

export const SyncLedDisplay = createContext<() => void>(() => console.log("default"));